<template>
    <v-app id="app">
        <core-view/>
    </v-app>
</template>

<script>
import View from './components/View';

export default {
    name: 'App',
    components: {
        'core-view': View,
    },
    beforeCreate() {
        if (this.$store.state.accessToken) {
           this.$http.defaults.headers.common['Authorization'] = "Basic " + this.$store.state.accessToken;
        }
    },
}
</script>

<style lang="scss">
@import './style/index.scss';
</style>